import gql from 'graphql-tag';

export const SaveApplicationEventMutation = gql`
  mutation ($applicationEvent: ApplicationEventInput!) {
    saveApplicationEvent (applicationEvent: $applicationEvent) 
    {
      id
    }
  }
`;
